import { Directive } from "@app/components/directive";
import { IColumnScope } from "@app/components/kb-column/kb-column.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { ApiService } from "@app/services/api.service";
import { DrawerService } from "@app/services/drawer.service";
import { ISearchScope } from "@app/views/search.view";

export interface ISearchGridScope extends ISearchScope<any> {
    scrollParent: string;
    drawerService: DrawerService;
}
    
@NgComponent({
    token: Token.KbSearchGrid,
    dependencies: [
        Token.DrawerService
    ]
})
export class KbSearchGrid extends Directive {
    constructor(
        drawerService: DrawerService
    ) {

        super();

        this.template = Dirs.component("kb-search-grid");
        this.restrict = "AE";
        this.scope = false;
        this.replace = true;
        this.transclude = {
            results: '?kbSearchGridResults',
            customResults: '?kbSearchGridCustomResults',
            toolbar: '?kbSearchGridToolbar'
        };

        this.controller = [
            "$scope",
            "$element",
            "$attrs",
            "$transclude",
            Token.ApiService.key,
            function(
                $scope: ISearchGridScope,
                $element: ng.IAugmentedJQuery,
                $attrs: ng.IAttributes,
                $transclude: ng.ITranscludeFunction,
                api: ApiService) {

            let columns: IColumnScope[] = $scope.columns = [];
            $scope.scrollParent = $attrs.scrollParent || "#search-content";
            $scope.drawerService = drawerService;

            let colDb = {};
            this.addColumn = (column: IColumnScope) => {
                if (!colDb[column.id]) {
                    colDb[column.id] = column;
                    
                    columns.push(column);
                    columns.sortBy(c => c.order);

                    // column.$on("$destroy", (event) => {
                    //    columns.remove(column);
                    // });

                    // set sort properties from query string                        
                    if (column.field && column.field == $scope.binding.search.sortField) {
                        column.sorted = true;
                        column.descending = $scope.binding.search.descending;
                    }
                }
            };

        }];
    }
}
